<app-modal [info]="info" (closeModal)="closeModal($event)">
  <ng-template #titleContent>
    <h3 class="modal__title">
      {{ data.title | translate: { name: data.name } }}
    </h3>
  </ng-template>
</app-modal>
